import { CloudOff, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * The boot screen for a server that could not be reached (September audit).
 *
 * A network failure on the first `/api/v1/auth/status` used to land on the
 * same sign-in card as a 401, so a reload with the connection down asked a
 * signed-in person for their password. Nothing about them changed; the
 * request did not get through. This says so, and the shell retries on its
 * own when the browser reports the connection back.
 *
 * Mounts below App's `i18nReady` gate, like `AuthScreens`, so `common` is
 * live here without a ready check.
 */
export function UnreachableScreen({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation("common");
  return (
    <main className="auth-page">
      <section className="auth-panel unreachable-panel" aria-labelledby="unreachable-title">
        <div className="auth-loading-mark" aria-hidden="true">
          <CloudOff size={26} />
        </div>
        <h1 id="unreachable-title">{t("auth.unreachableTitle")}</h1>
        <p className="inline-note">{t("auth.unreachableBody")}</p>
        <button type="button" className="primary" onClick={onRetry}>
          <RefreshCw size={18} /> {t("auth.unreachableRetry")}
        </button>
      </section>
    </main>
  );
}
